import ReportTable from './report-table.component'

export default ReportTable